import { whyItems } from '@/mocks/categories';

export default function WhyVigorbuy() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 border border-primary-300 text-primary-700 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
              Why Choose Us
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Why Buyers Use Vigorbuy Spreadsheet
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Thousands of smart buyers trust our directory for faster, safer, and smarter product discovery.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {whyItems.map((item) => (
              <div
                key={item.title}
                className="group p-6 md:p-7 bg-background-100 rounded-lg transition-all duration-300 hover:bg-primary-500"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-background-50 transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed group-hover:text-background-200 transition-colors duration-300">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}